<template>

    <ion-item lines="inset" class="ion-activatable ripple-parent" @click.stop="openSelectModal()" >
        <mdicon size="24px" slot="start" name="domain" class="text-medium"></mdicon>
        <ion-input :readonly="current_selected" @ionBlur="createLocationItem" placeholder="Naam bouwdeel" v-model="current_selected_name"></ion-input>
        <ion-button slot="end" color="primary" size="small" fill="clear">
            <ion-icon slot="icon-only" :icon="createOutline"></ion-icon>
        </ion-button>
    </ion-item>

    <ion-modal :is-open="isOpen" ref="modal" @willDismiss="onWillDismiss()" :initial-breakpoint="1"
        :breakpoints="[0, 1]">
        <ion-header>
            <ion-toolbar color="light">
                <ion-buttons slot="start">
                    <ion-button color="primary" @click="cancel">
                        <ion-icon slot="icon-only" :icon="close"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>{{ label }}</ion-title>
            </ion-toolbar>
        </ion-header>

        <ion-content force-overscroll color="light">
            <info-card class="mt-4"
                message="Tik op een bestaand bouwdeel om het te selecteren, of gebruik het plusje naast een bouwdeel om een nieuw bouwdeel toe te voegen." />
            <div style="position: relative; margin-bottom:70px;margin-top: 15px; margin-right: 15px; margin-left:15px">
                <tree-select v-if="location_items.length != 0" class="clt tree" @select="select"
                    @refresh="refreshAndClose" :inspection_id="inspection_id" :level="0" :children="toTree"
                    :not_selectable_uuids="not_selectable_uuids" :selected="current_selected">
                </tree-select>

                <ion-page v-else>
                    <ion-content>
                        <NoData></NoData>
                    </ion-content>
                </ion-page>
            </div>
        </ion-content>
    </ion-modal>
</template>

<script>
import { createOutline, close } from 'ionicons/icons';
import TreeSelect from './TreeSelect.vue';
import { arrayToTree } from "performant-array-to-tree";
import { db } from "@/services/db";
import NoData from '@/components/NoData'
import { IonModal, IonItem } from '@ionic/vue';
import uuid from '@/plugins/uuid';

export default {
    name: 'novacheck-row',
    props: {
        value: {
            type: String,
            default: null
        },
        field_name: {
            type: String,
            default: 'uuid'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        not_selectable_uuids: {
            type: Array,
            default: () => []
        },
        label: {
            type: String,
            default: 'Selecteer een bouwdeel'
        },
    },
    components: {
        TreeSelect,
        NoData,
        IonModal,
        IonItem

    },
    data() {
        return {
            createOutline,
            close,
            current_selected: null,
            current_selected_name: null,
            isOpen: false,
            location_items: [],
            original_current_selected_name: null,
        }
    },
    created() {
        this.refreshLocationItems();
    },
    methods: {
        async refreshAndClose(new_location_item) {
            this.select(new_location_item)
        },
        async refreshLocationItems() {
            const parent_location_item = null;

            await db.inspections.where({ id: this.$store.getters.getInspectionId }).first().then(async inspection => {
                await db.location_items.where({ location_id: inspection.location_id }).toArray().then(location_items => {
                    this.location_items = location_items
                    
                    // we set current selected to the first location item without parent_uuid
                    let location_item = this.location_items.find(item => !item.parent_uuid && item.location_id == inspection.location_id)
                    this.current_selected = location_item.uuid
                    this.current_selected_name = location_item.name
                })
            })

            if (this.$route.query.location_item_uuid) {
                this.current_selected = this.$route.query.location_item_uuid

                this.current_selected_name = this.selected
                this.original_current_selected_name = this.selected
            }
        },
        cancel() {
            this.$refs.modal.$el.dismiss(null, 'cancel');
        },
        async select(item) {
            await this.refreshLocationItems()
            this.location_item_component = item
            this.current_selected = item.uuid
            this.isOpen = false
        },
        openSelectModal() {
            this.isOpen = true
        },
        onWillDismiss() {
            this.isOpen = false
        },
        async createLocationItem() {

            if (!this.original_current_selected_name && !this.current_selected && this.current_selected_name) {

                const inspection = await db.inspections.where({ id: this.$store.getters.getInspectionId }).first()
                // we get the first location item by searching for the !parent_uuid and location_id
                let location_item = this.location_items.find(item => !item.parent_uuid && item.location_id == inspection.location_id)

                let new_location_item =
                {
                    created_by: this.$store.getters.getUser.id,
                    parent_uuid: location_item.uuid,
                    inspection_id: parseInt(this.$store.getters.getInspectionId),
                    location_id: location_item.location_id,
                    order_id: location_item.order_id + 1,
                    location_item_type_ids: [],
                    location_item_types: [],
                    uuid: uuid(),
                    name: this.current_selected_name,
                    in_inspection: true,
                }

                let state = {
                    opened: true,
                    uuid: location_item.uuid
                }

                this.$store.dispatch('setLocationItemState', state)

                let url = '/inspections/' + parseInt(this.$store.getters.getInspectionId) + '/bulk-location-items'
                await this.$requests.post('location_items', url, { location_items: [new_location_item] })

                // we set the new location item as selected
                this.select(new_location_item)
            }
        },
    },
    computed: {
        selected() {
            if (!this.current_selected) {
                return
            }

            let selected = this.location_items.find(item => item.uuid == this.current_selected)

            if (selected) {
                return selected.name
            }

            return null
        },
        toTree() {
            if (this.location_items && this.location_items.length > 0) {
                return arrayToTree(this.location_items, { id: "uuid", parentId: "parent_uuid", childrenField: "children", dataField: null })
            }
            return []
        },
    },
    watch: {
        value: {
            handler() {
                this.current_selected = this.value
            },
            immediate: true,
            deep: true
        },
        current_selected: {
            handler(newValue) {
                this.current_selected_name = this.selected

                this.$emit('change', newValue);
                this.$emit('update:value', newValue)
            },
            immediate: true,
            deep: true
        }
    }
}
</script>

<style>
.edit-icon {
    position: absolute;
    right: 15px;
    margin-top: 20px;
}
</style>
